<template>
  <GlobalWindow
      :title="title + module.name + '数据'"
      :visible.sync="visible"
      :confirm-working="isWorking"
      @confirm="confirm"
  >
    <el-form :model="form" ref="form">
      <el-form-item v-for="field in fields" :label="field.label" :prop="field.variable">
        <template>
          <el-input v-if="field.dataType === 'TEXT' || field.dataType === 'NUMBER'" v-model="form[field.variable]" v-trim/>
          <ImageUploader v-else-if="field.dataType === 'IMAGE'" :preview-url="form[field.variable]" :upload-success="getFieldUploadSuccessHandler(field)"/>
        </template>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import ImageUploader from '@/components/common/ImageUploader'
export default {
  name: 'OperaModuleDataWindow',
  extends: BaseOpera,
  components: { ImageUploader, GlobalWindow },
  data () {
    return {
      module: {},
      fields: [],
      // 表单数据
      form: {
        id: null
      }
    }
  },
  methods: {
    /**
     * 打开窗口
     *
     * @param title: 窗口标题
     * @param target: 行对象（仅编辑需该参数）
     * @param module: 模块
     */
    open (title, target, module) {
      this.title = title
      this.visible = true
      this.module = module
      this.fields = JSON.parse(module.fieldConfig)
      // 构建动态form
      this.form = { id: null }
      for (const field of this.fields) {
        this.$set(this.form, field.variable, '')
      }
      // 编辑
      if (target != null) {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
      }
    },
    // 获取字段值上传成功处理函数
    getFieldUploadSuccessHandler (field) {
      return (response) => {
        if (!response.success) {
          this.$tip.error(response)
          return
        }
        this.form[field.variable] = response.data.accessUri
      }
    },
    /**
     * 确认（点击确认按钮后触发）
     */
    confirm () {
      const value = {}
      for (const field of this.fields) {
        value[field.variable] = this.form[field.variable]
      }
      const form = {
        id: this.form.id,
        moduleId: this.module.id,
        value: JSON.stringify(value)
      }
      if (this.form[this.configData['field.id']] == null || this.form[this.configData['field.id']] === '') {
        this.__confirmCreate(form)
        return
      }
      this.__confirmEdit(form)
    }
  },
  created () {
    this.config({
      api: '/module/data',
      'field.id': 'id'
    })
  }
}
</script>
